import { getLocalStorageLanguage } from 'commons';
import { LANGUAGE_MAP } from 'constant/language';

const RAW_ORDER_PAYMENT_STATUS_MAP = {
  TO_BE_PAID: '1',
  PENDING_PAYMENT: '2',
  PENDING_APPROVAL: '3',
  PAID: '4',
  FAILED: '5',
  REFUNDED: '6',
} as const;

type OrderPaymentStatus =
  (typeof RAW_ORDER_PAYMENT_STATUS_MAP)[keyof typeof RAW_ORDER_PAYMENT_STATUS_MAP];

const isValidOrderPaymentStatus = (
  status: string,
): status is OrderPaymentStatus => {
  return Object.values(RAW_ORDER_PAYMENT_STATUS_MAP).includes(
    status as OrderPaymentStatus,
  );
};

const RAW_ORDER_PAYMENT_STATUS_CONFIG_MAP: Record<
  OrderPaymentStatus,
  {
    color: string;
    label: {
      [LANGUAGE_MAP.ZH_CN]: string;
      [LANGUAGE_MAP.EN]: string;
      [LANGUAGE_MAP.JA]: string;
    };
  }
> = {
  [RAW_ORDER_PAYMENT_STATUS_MAP.TO_BE_PAID]: {
    color: 'default',
    label: {
      [LANGUAGE_MAP.ZH_CN]: '待支付',
      [LANGUAGE_MAP.EN]: 'To Be Paid',
      [LANGUAGE_MAP.JA]: '未支払',
    },
  },
  [RAW_ORDER_PAYMENT_STATUS_MAP.PENDING_PAYMENT]: {
    color: 'default',
    label: {
      [LANGUAGE_MAP.ZH_CN]: 'pending支付',
      [LANGUAGE_MAP.EN]: 'Pending Payment',
      [LANGUAGE_MAP.JA]: '支払い待ち',
    },
  },
  [RAW_ORDER_PAYMENT_STATUS_MAP.PENDING_APPROVAL]: {
    color: 'default',
    label: {
      [LANGUAGE_MAP.ZH_CN]: 'pending审批',
      [LANGUAGE_MAP.EN]: 'Pending Approval',
      [LANGUAGE_MAP.JA]: '承認待ちの',
    },
  },
  [RAW_ORDER_PAYMENT_STATUS_MAP.PAID]: {
    color: '#27941d',
    label: {
      [LANGUAGE_MAP.ZH_CN]: '已支付',
      [LANGUAGE_MAP.EN]: 'Paid',
      [LANGUAGE_MAP.JA]: '支払い済み',
    },
  },
  [RAW_ORDER_PAYMENT_STATUS_MAP.FAILED]: {
    color: 'default',
    label: {
      [LANGUAGE_MAP.ZH_CN]: '已失败',
      [LANGUAGE_MAP.EN]: 'Failed',
      [LANGUAGE_MAP.JA]: '失敗した',
    },
  },
  [RAW_ORDER_PAYMENT_STATUS_MAP.REFUNDED]: {
    color: '#722ed1',
    label: {
      [LANGUAGE_MAP.ZH_CN]: '已退款',
      [LANGUAGE_MAP.EN]: 'Refunded',
      [LANGUAGE_MAP.JA]: '返金済み',
    },
  },
};

export const ORDER_PAYMENT_STATUS_MAP = new Proxy(
  RAW_ORDER_PAYMENT_STATUS_MAP,
  {
    ownKeys() {
      throw new Error('禁止遍历 ORDER_PAYMENT_STATUS_MAP');
    },
  },
);

export const ORDER_PAYMENT_STATUS_CONFIG_MAP = new Proxy(
  RAW_ORDER_PAYMENT_STATUS_CONFIG_MAP,
  {
    ownKeys() {
      throw new Error('禁止遍历 ORDER_PAYMENT_STATUS_CONFIG_MAP');
    },
  },
);

export const getOrderPaymentStatusLabel = (
  status: string | undefined | null,
) => {
  if (!status || !isValidOrderPaymentStatus(status)) {
    return '-';
  }

  const lang = getLocalStorageLanguage();
  return ORDER_PAYMENT_STATUS_CONFIG_MAP[status].label[lang];
};

export const getOrderPaymentStatusTagColor = (
  status: string | undefined | null,
) => {
  if (!status || !isValidOrderPaymentStatus(status)) {
    return 'default';
  }

  return ORDER_PAYMENT_STATUS_CONFIG_MAP[status].color;
};
